export const BankReconciliationHeaders = [
    {
        name: "Funding Date",
        value: "FundingDate"
    },
    {
        name: "Funding Group",
        value: "FundingGroup"
    },
    {
        name: "Payment Description",
        value: "PaymentDescription"
    },
    {
        name: "Batch Number",
        value: "BatchNumber"
    },
    {
        name: "Count",
        value: "Count"
    },
    {
        name: "Batch Amount",
        value: "BatchAmount"
    },
    {
        name: "i3 Credit Card",
        value: "i3CreditCard"
    },
    {
        name: "i3 ACH",
        value: "i3ACH"
    },
    {
        name: "i3 Returned Payment",
        value: "i3ReturnedPayment"
    },
    {
        name: "i3 Reversed Payment",
        value: "i3ReversedPayment"
    },
    {
        name: "uReceivables",
        value: "uReceivables"
    },
    {
        name: "uScan",
        value: "uScan"
    },
    {
        name: "Manual Deposit",
        value: "ManualDeposit"
    }
]